export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/da04de233862865f1bba5ab35a73b57a.jpg"
          alt="Hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 md:px-10 text-center">
        <div className="flex justify-center mb-8">
          <img
            src="https://public.readdy.ai/ai/img_res/7c732112-4909-4323-8a23-e32da04c1d7a.png"
            alt="KIRCI DOO Logo"
            className="h-20 md:h-28 w-auto object-contain drop-shadow-2xl"
          />
        </div>

        <h1 className="text-5xl md:text-7xl font-thin text-white tracking-tight leading-tight mb-6">
          KIRCI DOO
        </h1>

        <p className="text-lg md:text-xl text-white/70 font-light max-w-2xl mx-auto leading-relaxed mb-4">
          A team of experts developing modern applications for the iOS platform.
        </p>
        <p className="text-base md:text-lg text-white/50 font-light max-w-xl mx-auto leading-relaxed">
          Enhancing user experience &amp; improving the security of mobile devices.
        </p>

        {/* Scroll indicator */}
        <div className="mt-16 flex flex-col items-center gap-2 animate-bounce">
          <span className="text-white/40 text-xs uppercase tracking-widest">Scroll</span>
          <div className="w-px h-8 bg-white/30" />
        </div>
      </div>
    </section>
  );
}
